import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import PropTypes from "prop-types";
import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

const headCells = [
    {id: 'login', numeric: false, disablePadding: true, label: 'Аккаунт'},
    {id: 'name', numeric: false, disablePadding: false, label: 'Имя', align: 'center'},
    {id: 'siteName', numeric: false, disablePadding: false, label: 'Сайт'},
    {id: 'type', numeric: false, disablePadding: false, label: 'Тип'},
    {id: 'captcha', numeric: true, disablePadding: false, label: 'Капча', tooltip: 'Только для RomanceCompass и J4L'},
    {id: 'left', numeric: false, disablePadding: false, label: 'Осталось'},
    {id: 'left', numeric: false, disablePadding: false, label: 'Статус'},
    {id: 'subscription', numeric: false, disablePadding: false, label: <span>Тарифный <br /> план</span>, align: 'center'},
    {id: 'locked', numeric: false, disablePadding: false, label: <span>Разрешить <br /> активацию</span>, align: 'center'},
    {id: 'remove', numeric: false, disablePadding: false, label: ''},
    {id: 'smt', numeric: false, disablePadding: false, label: ''},
];

export function EnhancedTableHead(props) {
    const {classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort} = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color={'primary'}
                        indeterminate={numSelected > 0 && numSelected < rowCount }
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{'aria-label': 'select all desserts'}}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <Tooltip title={headCell.tooltip || null} disableHoverListener={!headCell.tooltip}>
                    <TableCell
                        key={headCell.id}
                        align={headCell.align ? headCell.align : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                    </Tooltip>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};